export default __webpack_public_path__ + "static/pound-d2285a391f8122cc40220100caf90c89.png";